import React, { Dispatch, SetStateAction } from 'react';
import { gql, useQuery } from '@common/hooks';
import { ErrorHandler } from '@common/components';
import { Form, Row, Col, Select } from 'antd';

const AddUnitsSelectFacilityStepQuery = gql`
  query AddUnitsSelectFacilityStepQuery {
    facilities: organizationBusinesses {
      id
      name
    }
  }
`;

type AddUnitsSelectFacilityStepQueryType = {
  facilities: {
    id: string;
    name: string;
  }[];
};

type Props = {
  selectedFacilityId: string | undefined;
  onChange: Dispatch<SetStateAction<string | undefined>>;
};

export function AddUnitsSelectFacilityStep({
  selectedFacilityId,
  onChange,
}: Props) {
  const { data, loading, error } =
    useQuery<AddUnitsSelectFacilityStepQueryType>(
      AddUnitsSelectFacilityStepQuery
    );

  if (error) {
    return <ErrorHandler error={error} log="AddUnitsSelectFacilityStep" />;
  }

  const options =
    data?.facilities?.map((ob) => ({
      value: ob.id,
      label: ob.name,
    })) || [];

  return (
    <Form layout="vertical">
      <Row>
        <Col span={8}>
          <Form.Item label="Facility">
            <Select
              placeholder="Select Facility"
              value={selectedFacilityId}
              onChange={onChange}
              disabled={loading}
              options={options}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
}
